<template>
  <div>
    <div v-if="dynamicObj.objectType == '分页'">
      <!-- <levelThree-template v-if="showLevelThree" :total="total"></levelThree-template>
      <find-direction-template
        v-if="showFindDirection"
        :total="total"
      ></find-direction-template> -->
      <div class="draggableDiv flex-warp">
        <div v-for="(listItem, listIndex) in requestList" :key="listIndex" :style="mubanObj.style">
          <mubanTemplateOne :attributeObj="{
              schoolPageInfo: listItem,
            }" :mubanObj="mubanObj"></mubanTemplateOne>
        </div>
        <div class="flex-end">
          <el-pagination v-if="pagination == 1" background @current-change="handleCurrentChange" :current-page.sync="pageNumber" :page-size="pageSize" layout="prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <div class="draggableDiv" :style="mubanObj.style" v-else-if="dynamicObj.objectType == '组合'">
      <div v-for="item in mubanObj.htmlStyleList" :key="item.id">
        <div v-if="item.label == 'div'" :style="item.style">
          <muban-template :attributeObj="{ schoolPageInfo: {} }" :mubanWidth="item.width" :dynamicObj="item.template"></muban-template>
        </div>
        <!-- 栅格 -->
        <el-row v-if="item.label == 'row'" :style="item.style">
          <el-col :span="Item.col" v-for="Item in item.htmlStyleList" :key="Item.id" :style="Item.style">
            <div style="width: 100%">
              <muban-template :attributeObj="{}" :mubanWidth="Item.width" :dynamicObj="Item.template"></muban-template>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="draggableDiv" :style="mubanObj.style" v-else>
      <mubanTemplateOne :attributeObj="attributeObj" :mubanObj="mubanObj"></mubanTemplateOne>
    </div>
  </div>
</template>
<script>
// import levelThreeTemplate from "../diyTemplate/levelThreeTemplate.vue";
import limitPurchase from '../diyTemplate/limitPurchase'
// import findDirectionTemplate from "../diyTemplate/findDirectionTemplate";
import mubanTemplateOne from "./mubanTemplateOne";
import { mapGetters } from "vuex";
import axios from "@/api/config";
export default {
  name: "mubanTemplate",
  components: { mubanTemplateOne, limitPurchase },
  props: {
    attributeObj: Object,
    mubanWidth: Number,
    dynamicObj: Object,
  },
  data () {
    return {
      showLevelThree: false,
      showFindDirection: false,
      total: 0,
      pagination: 0,
      pageSize: 1,
      requestUrl: "",
      requestList: [],
      pageNumber: 1,
      mubanObj: {},
      videoUrl:
        "http://1251150518.vod2.myqcloud.com/8d224e9cvodgzp1251150518/a775f1ae3701925920751120030/4RPCJ58Vki4A.mp4",
      defaultPic:
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
    };
  },

  watch: {
    dynamicObj: {
      handler: function (val) {
        this.initData(val);
      },
      deep: true,
    },
    mubanWidth () {
      this.initData(this.dynamicObj);
    },
  },
  methods: {
    initData (val) {
      if (!val) {
        return;
      }
      if (val.objectType == "分页") {
        let arr = val.event.split("?")[1].split("&");
        this.requestUrl = val.event.split("?")[0];
        let obj = {};
        arr.forEach((item) => {
          let itemArr = item.split("=");
          obj[itemArr[0]] = itemArr[1];
        });
        this.pageSize = obj.pageSize * 1;
        this.pagination = obj.pagination * 1;
        this.showLevelThree = obj.showLevelThree;
        this.showFindDirection = obj.showFindDirection;
        this.getList();
      }
      if (Object.keys(this.dynamicObj).length != 0) {
        let obj = JSON.parse(JSON.stringify(val));
        this.mubanObj = this.objectAssign(obj);
        let arr = [];
        obj.htmlStyleList.forEach((item) => {
          let subArr = [];
          if (item.htmlStyleList) {
            item.htmlStyleList.forEach((_item) => {
              subArr.push(this.objectAssign(_item));
            });
          }
          item.htmlStyleList = subArr;
          arr.push(this.objectAssign(item));
        });
        this.mubanObj.htmlStyleList = arr;
        this.adaptionSelf();
      }
    },
    objectAssign (obj) {
      let jsonObj = JSON.parse(obj.styleJson);
      return Object.assign({}, obj, jsonObj);
    },
    adaptionSelf () {
      this.mubanObj.style = this.getStyle(this.mubanObj);
      this.mubanObj.htmlStyleList.forEach((item) => {
        item.style = this.getStyle(item);
        if (item.htmlStyleList) {
          item.htmlStyleList.forEach((_item) => {
            _item.style = this.getStyle(_item);
          });
        }
      });
    },
    //拼接style
    getStyle (obj) {
      let per = this.mubanWidth / this.mubanObj.width;
      // let divWidth = obj.width * per;
      per = 1;
      // divWidth = divWidth - 20;
      return `box-sizing: border-box;${obj.width ? "width:" + obj.width * per + "px" : ""
        };${obj.height ? "height:" + obj.height * per + "px" : ""};${obj.padding ? "padding:" + obj.padding * per + "px" : ""
        };${obj.marginTop ? "margin-top:" + obj.marginTop * per + "px" : ""};${obj.marginLeft ? "margin-left:" + obj.marginLeft * per + "px" : ""
        };${obj.fontSize ? "font-size:" + obj.fontSize * per + "px" : ""};${obj.color ? "color:" + obj.color : ""
        };${obj.fontWeight ? "font-weight:" + obj.fontWeight : ""};${obj.textAlign ? "text-align:" + obj.textAlign : ""
        };${obj.background ? "background:" + obj.background : ""};${obj.borderRadius ? "border-radius:" + obj.borderRadius + "px" : ""
        };${obj.css}`;
    },
    getList () {
      let obj = {
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
      };
      obj = JSON.stringify(obj);
      axios({
        method: "post",
        url: process.env.BASE_URL + this.requestUrl,
        data: obj,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }).then((res) => {
        this.requestList = res.data.records || [res.data];
        this.total = res.data.total;
      });
    },
    handleCurrentChange (val) {
      this.pageNumber = val;
      this.getList();
    },
  },
  mounted () {
    this.initData(this.dynamicObj);
  },
};
</script>
<style scoped>
.draggableDiv {
  box-sizing: border-box;
}
.draggableDiv >>> .el-pagination {
  margin: 40px 0;
  padding: 0;
}
.flexList {
  display: flex;
  align-items: center;
}
.flex-warp {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.flex-end {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineSchool/template/mubanTemplate.vue